import React from 'react';
import styles from '../../styles/educationFair.module.scss';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useRouter } from 'next/router';
import useZipmeLink from '../../hooks/useZipmeLink';
import { isFrappeOrJotFormClass } from '../../utils/helpers';
import LazyReveal from '../LazyReveal';
interface Props {
  eventData: any;
}

const GrabChanceSection: React.FC<Props> = ({ eventData }) => {
  const { zipmeLink, generateLink } = useZipmeLink();
  const router = useRouter();
  return (
    <LazyReveal
      style={{
        background: `linear-gradient(0deg, ${
          eventData?.grabChanceSection?.sectionBgColorBottom || '#F7F8F7'
        } 50%, ${
          eventData?.grabChanceSection?.sectionBgColorTop || '#DBD9FC'
        } 0)`,
      }}
    >
      <div className={styles.studentFooter}>
        <Container>
          <Row>
            <Col>
              <div
                className={styles.session}
                style={{
                  backgroundColor: `${eventData?.grabChanceSection?.sectionBgColor}`,
                }}
              >
                <div>
                  <h3
                    style={{
                      color:
                        eventData?.titleTextColor ||
                        eventData?.grabChanceSection?.sectionTitleColor ||
                        '#fff',
                    }}
                  >
                    {eventData?.grabChanceSection?.sectionTitle}
                  </h3>
                </div>
                <div className={styles.anchor}>
                  <a
                    onClick={() => {
                      !eventData?.meta?.jotforms[0]?.jotformid &&
                       generateLink(eventData?.externalLink);
                    }}
                    className={`btn btn-primary   ${
                      eventData?.meta?.jotforms[0]?.jotformid
                        ? ` ${isFrappeOrJotFormClass(eventData?.meta?.jotforms[0]?.jotformid)}`
                        : ''
                    }`}
                  >
                    { eventData.grabChanceSection?.button?.label || 'Register Now' }
                  </a>
                  <script
                    dangerouslySetInnerHTML={{
                      __html: `window.lintrk('track', { conversion_id: 6870956 });`,
                    }}
                  />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </LazyReveal>
  );
};

export default GrabChanceSection;
